import { createMongoAbility, RawRuleOf } from '@casl/ability';

import { getCaslSubject } from '../decorators/casl-subject.decorator';
import { AppAbility } from '../types/app-ability';

/**
 * Create an ability for a user based on rules extracted from their role and permissions.
 * detectSubjectType lets `ability.can(action, dtoInstance)` resolve the subject from a
 * @CaslSubject-decorated DTO. String subjects passed to `throwUnlessCan(action, 'location')`
 * bypass detectSubjectType and are unaffected.
 * @param rules
 */
export const createAbility = (rules: RawRuleOf<AppAbility>[]) =>
  createMongoAbility<AppAbility>(rules, {
    detectSubjectType: (subject) =>
      getCaslSubject(subject) ??
      ((subject as { constructor?: { name?: string } })?.constructor
        ?.name as never),
  });
